import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight, Eye, EyeOff, Loader2, Building2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { getSlug, loginPath } from "@/lib/tenant";
import { AuthCard, Field, ForgotForm, inputCls, submitCls } from "@/pages/Login";

export const LoginBox = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const slug = getSlug();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await login(email, password, slug); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  if (forgot) return <ForgotForm email={email} tenant={slug} onBack={() => setForgot(false)} />;
  return (
    <AuthCard testId="home-login-box">
      <form onSubmit={submit} data-testid="home-login-form">
        <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-teal-400">Area riservata</span>
        <h2 className="mt-2 font-heading text-2xl font-semibold text-white">Accedi al pannello</h2>
        <div className="mt-6 space-y-4">
          <Field id="home-email" label="Email"><input id="home-email" type="email" required autoComplete="email" placeholder="nome@azienda.it" data-testid="home-login-email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Field id="home-password" label="Password">
            <div className="relative">
              <input id="home-password" type={show ? "text" : "password"} required autoComplete="current-password" data-testid="home-login-password" className={`${inputCls} pr-12`} value={password} onChange={(e) => setPassword(e.target.value)} />
              <button type="button" onClick={() => setShow(!show)} data-testid="home-toggle-password" aria-label="Mostra o nascondi password" className="absolute right-2 top-1/2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-lg text-slate-500 hover:bg-white/5 hover:text-slate-200">{show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</button>
            </div>
          </Field>
          {error && <div data-testid="home-login-error" className="flex items-center gap-3 rounded-xl border border-red-500/30 bg-red-500/10 p-3.5 text-sm text-red-300"><AlertCircle className="h-4 w-4 shrink-0" />{error}</div>}
          <button type="submit" disabled={busy} data-testid="home-login-submit" className={submitCls}>{busy ? <><Loader2 className="h-4 w-4 animate-spin" />Accesso in corso...</> : <>Accedi<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></>}</button>
        </div>
        <div className="mt-5 flex flex-wrap items-center justify-between gap-3 text-sm">
          <button type="button" data-testid="home-forgot-link" onClick={() => setForgot(true)} className="text-teal-400 hover:text-teal-300">Password dimenticata?</button>
          <Link to={loginPath()} data-testid="home-circuit-login" className="inline-flex items-center gap-1.5 text-slate-400 hover:text-white"><Building2 className="h-3.5 w-3.5" />Accedi al tuo circuito</Link>
        </div>
        <p className="mt-4 text-xs text-slate-600">Ogni circuito ha un accesso dedicato con il proprio logo: usa il link <span className="font-mono text-slate-500">/login/nome-circuito</span> ricevuto dal gestore.</p>
      </form>
    </AuthCard>
  );
};
